import { AppConfig } from '../../../app/app.config';
import { IJobFilters } from './job.reducer';

export interface IJobQueryParams {
    'filter[term]'?: string;
    'filter[jobStatus]'?: Array<string>;
    'filter[jobType]'?: string;
    'filterGte[jobDate]'?: string;
    'filterLte[jobDate]'?: string;
    'sort[jobDate]'?: string;
    'sort[jobStatus]'?: string;
    'sort[reference]'?: string;
    offset: number;
    limit: number;
}

export class JobFiltersToQueryConverter {

    getQuery(filters: IJobFilters): IJobQueryParams {

        const query = {} as IJobQueryParams;

        if (filters.searchTerm) {
            query['filter[term]'] = filters.searchTerm;
        }

        if (filters.jobStatus && filters.jobStatus.length > 0 && filters.jobStatus[0] !== '*') {
            query['filter[jobStatus]'] = filters.jobStatus;
        }

        if (filters.jobType && filters.jobType !== '*') {
            query['filter[jobType]'] = filters.jobType;
        }

        if (filters.sortBy) {
            query[`sort[${filters.sortBy}]`] = filters.sortDirection ? 'ASC' : 'DESC';
        }

        if (filters['filterGte[jobDate]']) {
            query['filterGte[jobDate]'] = filters['filterGte[jobDate]'];
        }

        if (filters['filterLte[jobDate]']) {
            query['filterLte[jobDate]'] = filters['filterLte[jobDate]'];
        }

        query.offset = filters.offset || 0;
        query.limit = filters.limit || AppConfig.JOB_LIST_PAGE.limit;

        return query;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job-filters-to-query-converter.ts